import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CompEmailTempCreateRequestDTO, CompEmailTempReadAllPaginatedDTO, CompEmailTempReadByTenantIdRequestDTO, CompEmailTempUpdateRequestDTO, CompEmailTempReadByIdRequestDTO, CompEmailTempDeleteRequestDTO, CompEmailItem, CompEmailList} from './company-email-templates.interface';
import { CompanyEmailTemplate_Create, CompanyEmailTemplate_Delete, CompanyEmailTemplate_ReadAll, CompanyEmailTemplate_ReadById, CompanyEmailTemplate_ReadByTenantId, CompanyEmailTemplate_Update, CompanyEmailTemplate_ReadAllPaginated} from 'src/app/GlobalVariables';
import { EmailConfigReadAllRequestDTO } from 'src/app/notification/email-config/email-config.interface';
import { resolveTenantUrl, tenantOverrideOptions } from 'src/app/Common/ApiConfigurationService/resolve-tenant-url.util';

@Injectable({
  providedIn: 'root'
})
export class EmailService {

  constructor() { }

  http = inject(HttpClient);

  CompanyEmailTemplate_Create(data: CompEmailTempCreateRequestDTO): Observable<CompEmailItem> {
    return this.http.post<CompEmailItem>(CompanyEmailTemplate_Create, data);
  }

  CompanyEmailTemplate_Update(data: CompEmailTempUpdateRequestDTO): Observable<CompEmailItem> {
    return this.http.post<CompEmailItem>(CompanyEmailTemplate_Update, data);
  }

  CompanyEmailTemplate_Delete(data: CompEmailTempDeleteRequestDTO): Observable<void> {
    return this.http.post<void>(CompanyEmailTemplate_Delete, data);
  }

  CompanyEmailTemplate_ReadAll(data: EmailConfigReadAllRequestDTO): Observable<CompEmailList> {
    return this.http.get<CompEmailList>(CompanyEmailTemplate_ReadAll);
  }

  CompanyEmailTemplate_ReadById(data: CompEmailTempReadByIdRequestDTO): Observable<CompEmailItem> {
    return this.http.post<CompEmailItem>(CompanyEmailTemplate_ReadById, data);
  }

  CompanyEmailTemplate_ReadByTenantId(data: CompEmailTempReadByTenantIdRequestDTO): Observable<CompEmailList> {
    return this.http.post<CompEmailList>(CompanyEmailTemplate_ReadByTenantId, data);
  }

  // baseUrlOverride (optional): the viewed tenant's own AM gateway origin,
  // e.g. CompanyDetailComponent.apiConfigOverride.AM. Omitted for every
  // other caller - behaves exactly as before.
  CompanyEmailTemplate_ReadAllPaginated(data: CompEmailTempReadAllPaginatedDTO, baseUrlOverride?: string, companyId?: string | number, branchId?: string | number): Observable<CompEmailList> {
    return this.http.post<CompEmailList>(resolveTenantUrl(CompanyEmailTemplate_ReadAllPaginated, baseUrlOverride), data, tenantOverrideOptions(baseUrlOverride, companyId ?? 0, branchId ?? 0));
  }

}